// utils/GlobalMetadata.ts
export interface GlobalMeta {
    siteName: string;
    description: string;
    siteUrl: string;
    type: string;
    ogImg: string;
  }

  const globalMeta: GlobalMeta = {
    siteName: 'Lektuarium.pl',
    description: 'Pożycz książki innym.',
    siteUrl: 'https://lektuarium.com',
    type: 'website',
    ogImg: 'https://lektuarium.com/logo_lektuarium_pl_rect.webp',
  };

  export default globalMeta;